import React, {useEffect, useState} from 'react';
import {Row, Col, Modal} from 'reactstrap';
import InputCustom from "@pages/components/InputCustom";
import {InputArraySelect, InputKeySelect} from "@pages/components/InputSelect";
import InputFile from "@pages/components/InputFile";
import {jobCategories,API_CORE_URL} from "@constants/index";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import axios from "axios";
import notify from "@utils/notify";


export default function UserForm({
                                     addModal,
                                     setAddModal,
                                     roles,
                                     jobCategories,
                                     submitData,
                                     resetData,
                                     defaultValues = {}
                                 }) {
    const [user, setUser] = useState({
        name: '',
        email: '',
        role_id: '',
        photo: null,
        preview: null,
        password: '',
        password_confirmation: '',
        department_id: '',
        is_driver: 0,
        ...defaultValues
    });
    const addUser = () => {
        let formData = new FormData();
        formData.append('name', user.name);
        formData.append('email', user.email);
        formData.append('role_id', user.role_id);
        formData.append('is_driver', user.is_driver);
        if (user?.photo) {
            formData.append('photo', user.photo);
        }
        formData.append('department_id', typeof user.department_id === 'undefined' || ['undefined', null, 'null', '-'].includes(user.department_id) ? '' : user.department_id);
        formData.append('password', user.password);
        formData.append('password_confirmation', user.password_confirmation);

        axios({
            method: 'POST',
            url: API_CORE_URL + '/user',
            data: formData
        })
            .then(response => {
                if (response.status === 201) {
                    const data = response.data.data;
                    submitData({data})
                    setAddModal(false);
                }
            })
            .catch(error => {
                console.error('error :: ', error);
                if (error.response.status === 422) {
                    let errors = error.response.data.errors;
                    setErrors(errors);
                    resetData()
                    return
                }
                setAddModal(false);
                notify.warning(error.response? error.response.statusText: 'Error occurred.');
            })
    }
    const [isNotValid, setIsNotValid] = useState(true);

    useEffect(()=>{
        if (!user.name || !user.email || !user.role_id) {
            setIsNotValid(true)
        } else setIsNotValid(false)
    },[user])

    const [errors, setErrors] = useState({});


    const handleChange = async (file) => {
        if (file) {
            let reader = new FileReader();
            reader.readAsDataURL(file)
            const preview =  URL.createObjectURL(file)
            setUser({
                ...user,
                photo: file,
                preview: preview,
            });
        }
    }
    const clearFile = () => {
        setUser({
            ...user,
            photo: null,
            preview: null,
        });
    }

    return (
        <Modal
            isOpen={addModal}
            toggle={() => setAddModal(false)}
            size="lg"
            className="modal-dialog-centered modal-secondary"
        >
            <div className="modal-header">
                <h2 className="title">User Information</h2>
            </div>
            <div className="modal-body">
                <Row>
                    <Col md={6}>
                        <InputCustom
                            newLabel={`Name`}
                            placeholder={`Name`}
                            column={true}
                            required={true}
                            checkValid={false}
                            onChange={(e) => setUser({
                                ...user,
                                name: e.target.value
                            })}
                            invalid={errors && errors.name? true: false}
                            errorMessage={errors.name}
                        />
                    </Col>
                    <Col md={6}>
                        <InputCustom
                            newLabel={`Email`}
                            checkEmail
                            required
                            checkValid={false}
                            column
                            placeholder={`Email`}
                            onChange={(e) => setUser({
                                ...user,
                                email: e.target.value
                            })}
                            invalid={errors && errors.email? true: false}
                            errorMessage={errors.email}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <InputArraySelect
                            label={`Role`}
                            required
                            placeholder={`Role`}
                            value={user?.role_id}
                            options={roles}
                            onChange={(e) => setUser({
                                ...user,
                                role_id: e.target.value
                            })}
                            valueKey={`id`}
                            labelKey={`name`}
                            defaultOption={true}
                            invalid={errors && errors.role_id? true: false}
                            errorMessage={errors.role_id}
                        />
                    </Col>
                    <Col md={6}>
                        <InputFile
                            label={`Profile photo`}
                            placeholder={`Select file`}
                            preview={user?.preview}
                            clearFile={clearFile}
                            onChange={(e) => handleChange(e.target.files[0])}
                            invalid={errors && errors.photo? true: false}
                            errorMessage={errors.photo}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <InputCustom
                            type={`password`}
                            newLabel={`Password`}
                            column
                            placeholder={`Password`}
                            onChange={(e) => setUser({
                                ...user,
                                password: e.target.value
                            })}
                            invalid={errors && errors.password? true: false}
                            errorMessage={errors.password}
                        />
                    </Col>
                    <Col md={6}>
                        <InputCustom
                            type={`password`}
                            newLabel={`Confirm password`}
                            column
                            placeholder={`Confirm password`}
                            onChange={(e) => setUser({
                                ...user,
                                password_confirmation: e.target.value
                            })}
                            invalid={errors && errors.password_confirmation? true: false}
                            errorMessage={errors.password_confirmation}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <InputKeySelect
                            label={`Job Category`}
                            options={jobCategories}
                            value={user?.department_id}
                            onChange={(e) => setUser({
                                ...user,
                                department_id: e.target.value
                            })}
                            defaultOption={true}
                            invalid={errors && errors.department_id ? true : false}
                            errorMessage={errors.department_id}
                        />
                    </Col>
                    <Col md={6}>
                        <div className={'d-flex flex-column'}>
                            <label className="form-control-label">Is driver</label>
                            <label className="custom-toggle">
                                <input
                                    type="checkbox"
                                    onChange={() => {
                                        setUser({
                                            ...user,
                                            is_driver: !!user?.is_driver === false ? 1 : 0
                                        })
                                    }}
                                />
                                <span
                                    className="custom-toggle-slider rounded-circle"
                                    data-label-off="No"
                                    data-label-on="Yes"
                                />
                            </label>
                        </div>

                    </Col>
                </Row>


            </div>
            <div className="modal-footer">
                <ButtonContainer
                    reverse
                    disabled={isNotValid}
                    onClick={() => addUser()}
                >
                    Save
                </ButtonContainer>
                <ButtonContainer
                    onClick={() => setAddModal(false)}
                >
                    Cancel
                </ButtonContainer>
            </div>
        </Modal>
    );
}